//@flow
import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import { FilterButton } from 'components/atoms/filtersButton';
import { ListMobileCarousel } from 'components/molecules/listMobileCarousel';
import MapComponent from 'components/molecules/map';
import { useViewport } from 'components/templates/viewportProvider';

type Props = {
  data: Object,
  list: Array,
  updateFilter: () => void,
  updateMapView: () => void,
  onClick: () => void,
  fetchTitle: Component,
  mapView: boolean,
  pinLocation: any,
  filterType: string,
  filterContent?: Component,
  activeFilters?: Array<string>,
  objectFit?: string,
  vertical?: string,
};

export const ListMapMobile = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    data,
    list,
    type,
    types,
    updateFilter,
    updateMapView,
    fetchTitle,
    onClick,
    mapView,
    pinLocation,
    filterType,
    filterContent,
    activeFilters = [],
    objectFit,
    vertical,
  } = props;
  const styleOnMap = mapView ? '#000000' : '';

  const switchView = () => {
    if (mapView === true) {
      updateMapView('dark-theme', false);
    } else {
      updateMapView('light-theme', true);
    }
  };

  return (
    <div className={'project-browser-mobile-container'} style={{ height }}>
      <div className={'project-filter-sec'}>
        <FilterButton
          className={`project-filter-mobile ${
            activeFilters.length > 0 ? 'highlight' : ''
          }`}
          isMobile={isMobile}
          theme={mapView ? 'dark-theme' : 'light-theme'}
          filterType={filterType}
          filterContent={filterContent}
          activeFilters={activeFilters}
        />
      </div>
      <div className={'mobile-map-container'}>
        <MapComponent
          mapStyles={'project-map'}
          data={list}
          updateFilter={updateFilter}
          type={filterType}
          types={types}
          pinLocation={pinLocation}
        />
      </div>
      <div
        style={{ visibility: mapView ? 'hidden' : 'visible' }}
        className={'mobile-list-view-container'}
      >
        <ListMobileCarousel
          data={list}
          type={type}
          count={'0'}
          fetchTitle={fetchTitle}
          onClick={onClick}
          objectFit={objectFit}
          vertical={vertical}
        />
      </div>
      <Row className={'view-switch'}>
        <b>
          <span style={{ backgroundColor: styleOnMap }} onClick={switchView}>
            {mapView ? 'LIST VIEW' : 'SHOW MAP'}
          </span>
        </b>
      </Row>
    </div>
  );
};
